export const DO_LOADING = 'DO_LOADING';
export const DO_TRIGGER = 'DO_TRIGGER';
export const DO_SWITCH_ON = 'DO_SWITCH_ON';
export const DO_SWITCH_OFF = 'DO_SWITCH_OFF';
export const POP_UP = 'POP_UP';
